module.exports = __webpack_public_path__ + "static/006708-bec28bbc8a1e161c909a4de4738cf0da.jpg";